import { InputField, LabelField, MyCheckbox, SelectField } from "components";
import React, { useEffect, useMemo, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { DatePickerField } from "_metronic/_partials/controls";
import FinanceAccordion from "../Accordion";
import { PriceType } from "./PercentageFixed";
import TributeInformation from "./TributeInformation";
import FinanceService from "../../../../Lib/API/Finance";
import { getAccessTokenSilently } from "utils/functions";
import { useSearch } from "hook";
import Select, { components } from "react-select";
import RightArrowSvg from "../../../../assets/icons/svg/RightArrowSvg.js";
import FinanceSettingService from "../../../../Lib/API/FinanceSetting/FinanceSetting";
import { toastr } from "react-redux-toastr";
import { FontColors } from "theme/fontConfig";

const Donation = ({ types, setShow, show, index, ...props }) => {
  const [split, setSplit] = useState(false);
  const [loading, setLoading] = React.useState(false);
  const [expanded, setExpanded] = React.useState(false);
  const [taxType, setTaxType] = useState("%");
  const [search, setSearch] = useState("");
  const { searchAction } = useSearch({ action: setSearch });
  const [data, setData] = useState();
  const [ledgers, setLedgers] = useState();
  const [ledgerSubLedgerData, setLedgerSubLedgerData] = useState("");
  const [ledgerSubLedgerName, setLedgerSubLedgerName] = useState("");
  const [ledgerSubLedgerId, setLedgerSubLedgerId] = useState("");
  const [subLedgerOptions, setSubLedgerOptions] = useState();

  const formik = props;

  const regex = /([0-9]*[\.|\,]{0,1}[0-9]{0,2})/s;

  const enableLoading = (value) => {
    setLoading(value);
  };
  const exceptThisSymbols = ["e", "E", "+", "-"];

  const preventArrows = (e) => {
    if (e.which === 38 || e.which === 40 || exceptThisSymbols.includes(e.key))
      e.preventDefault();
  };
  useEffect(() => {
    formik.setFieldValue("type_of_charge", "donation");
    if (formik.values?.nextPayment === false) {
      formik.setFieldValue(`account_name`, {
        id: "",
        name: "",
      });
      formik.setFieldValue(`values.${index}.Ledger`, {
        id: "",
        name: "",
      });
      formik.setFieldValue(`values.${index}.SubLedger`, {
        id: "",
        name: "",
      });
      formik.setFieldValue(`values.${index}.due_date`, "");
      formik.setFieldValue(`values.${index}.tax`, "");
      formik.setFieldValue(`values.${index}.total_amount`, "");
      formik.setFieldValue(`values.${index}.discount`, "");
      formik.setFieldValue("note", "");
    }
  }, []);

  const formatOptionLabel = ({ label, account_id }) => {
    return (
      <div className="dropdown-container" key={account_id}>
        <div className="icon-name-container d-flex align-items-center justify-content-start">
          <div className="name-container" style={{ marginInlineStart: 10 }}>
            <div>{label}</div>
          </div>
        </div>
      </div>
    );
  };
  const getTaxValue = formik.values.values[index]?.tax ?? 0;

  const total = useMemo(() => {
    const acutalTotal = formik.values.values.reduce((a, b) => {
      return a + (b?.total_amount ?? 0);
    }, 0);
    const totalAmount = formik.values.values.reduce((a, b) => {
      const getTotalAmount = a + (b?.total_amount ?? 0);

      // const getFinalAmount =
      //   b?.tax_type === "%" && getTaxValue > 1
      //     ? getTotalAmount +
      //       (getTotalAmount / 100) * (getTaxValue < 1 ? 0 : getTaxValue)
      //     : getTotalAmount + getTaxValue;
      return getTotalAmount;
    }, 0);
    formik.setFieldValue("current_total", totalAmount);
    formik.setFieldValue("actual_total", acutalTotal);
    return Number.isNaN(totalAmount) ? 0 : totalAmount;
  }, [formik.values.values]);
  const changeAmount = useMemo(() => {
    const newAmount =
      formik.values?.values[0].split_duration === "day"
        ? total / formik.values?.values[0].number_of_split
        : formik.values?.values[0].split_duration === "week"
        ? total / (formik.values?.values[0].number_of_split * 7)
        : formik.values?.values[0].split_duration === "month"
        ? total / (formik.values?.values[0].number_of_split * 30)
        : formik.values?.values[0].split_duration === "quarter"
        ? total / (formik.values?.values[0].number_of_split * 90)
        : formik.values?.values[0].split_duration === "year"
        ? total / (formik.values?.values[0].number_of_split * 365)
        : "";

    formik.setFieldValue("change", newAmount);
    return Number.isNaN(newAmount) ? 0 : newAmount;
  }, [formik.values.values]);

  const colourStyles = {
    control: (styles) => ({
      ...styles,
      ...selectControlStyles,
    }),
  };

  const selectControlStyles = {
    backgroundColor: "#F3F6F9",
    borderColor: "#F3F6F9",
    color: FontColors.Slate3F4254,
    transition:
      "color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease",
    paddingTop: "6px",
    paddingBottom: "6px",
    cursor: "pointer",
  };
  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <RightArrowSvg label="Emoji" />
      </components.DropdownIndicator>
    );
  };
  useEffect(() => {
    async function fetchMyAPI() {
      enableLoading(true);
      const token = await getAccessTokenSilently();
      await FinanceService.getACcountNames(token, search)
        .then((res) => {
          if (res?.accounts) {
            res.accounts.map((item) => {
              item.label = item.family_name;
              item.value = item.account_id;
              return item;
            });
            setData(res?.accounts);
          }
          enableLoading(false);
        })
        .catch((err) => {
          enableLoading(false);
          toastr.error("Error", err?.data?.message);
        });
    }
    async function getLedgeraccounts() {
      enableLoading(true);
      const token = await getAccessTokenSilently();
      const res = await FinanceService.getLedgerAccountsForDonation(
        "donation",
        token
      );
      if (res?.ledgers) {
        setLedgers(res?.ledgers);
      }
      enableLoading(false);
    }
    getLedgeraccounts();
    fetchMyAPI();
  }, [search, getAccessTokenSilently]);
  const getLedgerSubLedgerListById = async (event) => {
    formik.setFieldValue(`values.${index}.Ledger`, {
      id: event.value,
      name: event.label,
      account_receivable: event?.account_receivable,
    });
    const ksubLedgers = ledgers?.find((item) => event.value === item._id);
    setSubLedgerOptions(ksubLedgers?.sub_ledgers);
    formik.setFieldValue(`values.${index}.SubLedger`, {
      id: "",
      name: "",
    });
    formik.setFieldValue(`values.${index}.tax`, event?.amount_detuctible);
    formik.setFieldValue(`values.${index}.total_amount`, event?.default_amount);
    formik.setFieldValue(`convenient_fee`, event?.gateway_fee);
  };
  const onSubledgerChange = (e) => {
    formik.setFieldValue(`values.${index}.SubLedger`, {
      id: e.value,
      name: e.label,
    });
    formik.setFieldValue(`values.${index}.tax`, e?.amount_detuctible);
    formik.setFieldValue(`values.${index}.total_amount`, e?.default_amount);
    formik.setFieldValue(`convenient_fee`, e?.gateway_fee);
    formik.setFieldValue(`require_notes`, e?.notes);
  };

  const options =
    ledgers &&
    ledgers?.map((item) => {
      return {
        label: item?.ledger_name,
        value: item?._id,
        tex: item?.amount_detuctible,
        default_amount: item?.default_amount,
        gateway_fee: item?.gateway_fee,
        notes: item?.notes,
        account_receivable: item?.account_receivable,
      };
    });
  const subLedgersList =
    subLedgerOptions &&
    subLedgerOptions?.map((item) => {
      return {
        label: item.sub_ledger_name,
        value: item._id,
        tex: item?.amount_detuctible,
        default_amount: item?.default_amount,
        gateway_fee: item?.gateway_fee,
        notes: item?.notes,
      };
    });

  const [calculatedAmount, setCalculatedAmount] = useState("00");
  let commingAmount = formik.values?.values?.[index]?.charge?.amount
    ? formik.values?.values?.[index]?.charge?.amount
    : formik?.values?.allData
    ? formik?.values?.allData[0].total_amount
    : formik.values?.values?.[index]?.total_amount
    ? formik.values?.values?.[index]?.total_amount
    : "";

  const getCommaSeperatedValue = (num) => {
    return (
      parseFloat(num?.toString().replace(/,/g, ""))
        .toFixed(2)
        ?.toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",") ?? 0.0
    );
  };
  return (
    <div className="renderd-comp">
      <form
        onSubmit={formik.handleSubmit}
        className="form fv-plugins-bootstrap fv-plugins-framework"
      >
        <div className="charge-tab donation-tab col-sm-12 px-sm-15 pt-10 pb-3 ">
          <Row className="form-row sm-12 mb-4">
            <Col className="col-12 col-md-5">
              <div className="form-group">
                <LabelField mandatory title={"Account Name"} />
                <Select
                  {...{
                    formik,
                    name: `account_name`,
                    checkValidation: false,
                  }}
                  onInputChange={(text) => searchAction(text)}
                  classNamePrefix="react-select"
                  formatOptionLabel={formatOptionLabel}
                  options={data}
                  isLoading={loading}
                  styles={colourStyles}
                  onChange={(value) => {
                    formik.setFieldValue(`account_name`, {
                      id: value._id,
                      name: value.label,
                    });
                  }}
                  value={
                    formik.values?.account_name
                      ? {
                          label: formik.values?.account_name?.name,
                          value: formik.values?.account_name?.id,
                        }
                      : ""
                  }
                  components={{ DropdownIndicator }}
                  isDisabled={index > 0}
                />
              </div>
            </Col>
            <Col className="col-12 col-md-5">
              <div className="form-group">
                <LabelField title="Charge Type" />
                <div className="charge-type">
                  {types.map((type, idx) => (
                    <span
                      className={
                        type === "Credit On Account" ? "col-sm-6" : "col-sm-3"
                      }
                      style={
                        type === show
                          ? { background: "#2555ef", color: FontColors.White }
                          : {}
                      }
                      key={idx}
                      onClick={() => {
                        setShow(type);
                        formik.setFieldValue(
                          `values.${index}.charge_type`,
                          type.toLowerCase()
                        );
                      }}
                      {...{
                        formik,
                        value: formik.values.values?.[index]?.charge_type,
                      }}
                    >
                      {type}
                    </span>
                  ))}
                </div>
              </div>
            </Col>
          </Row>
          {/* donation */}
          <Row className="form-row sm-12 mb-4">
            <Col className="col-12 col-md-5">
              <DatePickerField
                disabled={true}
                mandatory="true"
                {...{
                  formik,
                  name: `values.${index}.payment_date`,
                  title: "Date",
                  checkValidation: false,
                  value: formik.values.values?.[index]?.payment_date,
                }}
                financeDateFields="finance_datefield"
              />
            </Col>
            <Col className="col-12 col-md-5">
              <DatePickerField
                mandatory
                {...{
                  formik,
                  name: `values.${index}.due_date`,
                  title: "Due Date",
                  checkValidation: false,
                  minDate: formik.values.values?.[index]?.payment_date,
                  value: formik.values.values?.[index]?.due_date,
                }}
                financeDateFields="finance_datefield"
              />
            </Col>
          </Row>
          <Row className="form-row sm-12 mb-4">
            <Col className="col-12 col-md-5">
              <div className="form-group">
                <LabelField mandatory title={"Ledger Account"} />
                <Select
                  {...{
                    formik,
                    name: `values.${index}.Ledger`,
                    checkValidation: false,
                  }}
                  onInputChange={(text) => searchAction(text)}
                  classNamePrefix="react-select"
                  formatOptionLabel={formatOptionLabel}
                  options={options}
                  isLoading={loading}
                  styles={colourStyles}
                  onChange={getLedgerSubLedgerListById}
                  value={{
                    label: formik.values?.values?.[index]?.Ledger ? (
                      formik.values?.values?.[index]?.Ledger?.name
                    ) : (
                      <span style={{ color: FontColors.GrayB5B5C3 }}> Select</span>
                    ),
                    value: formik.values?.values?.[index]?.Ledger?.id,
                  }}
                  components={{ DropdownIndicator }}
                />
              </div>
            </Col>
            <Col className="col-12 col-md-5">
              <div className="form-group">
                <LabelField title={"Sub-Ledger Account"} />
                <Select
                  {...{
                    formik,
                    name: `values.${index}.SubLedger`,
                    checkValidation: false,
                  }}
                  onInputChange={(text) => searchAction(text)}
                  classNamePrefix="react-select"
                  formatOptionLabel={formatOptionLabel}
                  options={subLedgersList}
                  isLoading={loading}
                  styles={colourStyles}
                  onChange={onSubledgerChange}
                  value={{
                    label: formik.values?.values?.[index]?.SubLedger ? (
                      formik.values?.values?.[index]?.SubLedger?.name
                    ) : (
                      <span style={{ color: FontColors.GrayB5B5C3 }}> Select</span>
                    ),
                    value: formik.values?.values?.[index]?.SubLedger?.id,
                  }}
                  components={{ DropdownIndicator }}
                />
              </div>
            </Col>
          </Row>
          <Row className="form-row sm-12 mb-4">
            <Col className="col-12 col-md-5 d-flex">
              <Col className="col-sm-6 px-0">
                <InputField
                  type="number"
                  {...{
                    formik,
                    title: "Tax Deductible",
                    name: `values.${index}.tax`,
                    placeholderIcon: (
                      <span className="placeholder-icon">
                        {formik.values?.values?.[index]?.tax_type ||
                        formik?.values?.allData[0]?.discount_type === "%"
                          ? "%"
                          : "$"}
                      </span>
                    ),
                    placeholder: "Tax",
                    value: formik.values?.values?.[index]?.tax ?? "0",
                  }}
                  onKeyDown={(e) => preventArrows(e)}
                  min="0"
                  handleChange={(e) => {
                    formik.setFieldValue(
                      `values.${index}.tax`,
                      e.target.value.match(regex)[0]
                    );
                  }}
                />
              </Col>
              <Col className="col-12 col-md-5 price-type">
                <PriceType
                  value={
                    formik.values?.values?.[index]?.tax_type
                      ? formik.values?.values?.[index]?.tax_type
                      : formik?.values?.allData[0].tax_type
                  }
                  handleClick={setTaxType}
                  setFieldValue={formik.setFieldValue}
                  index={index}
                  type={`values.${index}.tax_type`}
                />
              </Col>
            </Col>
            <Col className="col-12 col-md-5">
              <InputField
                mandatory
                type="number"
                {...{
                  formik,
                  title: "Amount",
                  name: `values.${index}.total_amount`,
                  placeholder: "Charge Amount $",
                  value: formik.values?.values?.[index]?.total_amount,
                }}
                onKeyDown={(e) => preventArrows(e)}
                min="0"
                handleChange={(e) => {
                  formik.setFieldValue(
                    `values.${index}.total_amount`,
                    e.target.value.match(regex)[0]
                  );
                }}
                // onKeyDown={(e) =>
                //   exceptThisSymbols.includes(e.key) && e.preventDefault()
                // }
              />
            </Col>
          </Row>
          <Col className="col mb-10 px-0">
            <div className="">
              <MyCheckbox
                name={`values.${index}.is_splitted`}
                title="Split"
                handlechange={() => {
                  formik.setFieldValue(`values.${index}.is_splitted`, !split);
                  setSplit(!split);
                }}
                value={formik.values.values[index]?.is_splitted}
              />
            </div>
            {split && (
              <Row>
                <div className="col-sm-5">
                  <SelectField
                    {...{
                      formik,
                      name: `values.${index}.split_duration`,
                      items: ["day", "week", "month", "quarter", "year"],
                      value: formik.values.values?.[index]?.split_duration,
                      placeholder: "Select",
                    }}
                    onClick={(data) =>
                      formik.setFieldValue(
                        `values.${index}.split_duration`,
                        data
                      )
                    }
                  />
                </div>
                {formik.values.values?.[index]?.split_duration ? (
                  <div className="col-sm-3">
                    <InputField
                      type="number"
                      {...{
                        formik,
                        title: "",
                        name: `values.${index}.number_of_split`,
                        placeholder: "0",
                        value: formik.values.number_of_split,
                      }}
                    />
                    <div className="placeholder-div">
                      <p>
                        {formik.values.values?.[index]?.split_duration ??
                          "year"}
                      </p>
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </Row>
            )}
          </Col>
          <hr className="mt-10 mb-7" />
          <p className="charge-total mb-0">
            Total: $
            {formik.values?.values?.[index]?.total_amount
              ? getCommaSeperatedValue(formik.values?.current_total)
              : "0.00"}
            {/* Total: ${calculatedAmount ? calculatedAmount : 0} */}
          </p>

          <Row className="form-row sm-12 mb-4" style={{ marginTop: -10 }}>
            <Col className="col-sm-5">
              <InputField
                {...{
                  formik,
                  title: "Assign Tribute to",
                  name: "assign_email",
                  placeholder: "Asignee email",
                }}
              />
            </Col>
            <Col className="col-sm-7" style={{ alignSelf: "center" }}>
              <span className="assign">Assign</span>
            </Col>
          </Row>
          <div className="mb-4">
            <FinanceAccordion
              body={<TributeInformation data={data} />}
              header={<>Tribute information</>}
              expanded={expanded}
              onChange={() => setExpanded(!expanded)}
              formik={formik}
            />
          </div>
        </div>
      </form>
    </div>
  );
};

export default Donation;
